export const PORTAL_ACTIVE_INSTALLATION_KEY = 'portal_active_installation_id'

function collectInstallations(session) {
  const fromOrgs = (session?.organizations || []).flatMap((o) => o.installations || [])
  const direct = session?.installations || []
  const byId = new Map()
  for (const inst of [...fromOrgs, ...direct]) {
    if (inst?.id) byId.set(Number(inst.id), inst)
  }
  return [...byId.values()]
}

export function persistPortalActiveInstallationId(id) {
  if (!id) return
  try {
    sessionStorage.setItem(PORTAL_ACTIVE_INSTALLATION_KEY, String(id))
  } catch (_) {}
}

export function resolvePortalActiveInstallationId(session) {
  const installations = collectInstallations(session)
  try {
    const stored = Number(sessionStorage.getItem(PORTAL_ACTIVE_INSTALLATION_KEY))
    if (stored && installations.some((i) => Number(i.id) === stored)) {
      return stored
    }
  } catch (_) {}
  return installations[0]?.id || null
}

/** Installations visible for one org (nested payload or flat session list). */
export function installationsForOrganization(session, organizationId) {
  const orgId = Number(organizationId)
  if (!orgId) return session?.installations || []
  for (const org of session?.organizations || []) {
    if (Number(org.id) === orgId && Array.isArray(org.installations) && org.installations.length) {
      return org.installations
    }
  }
  return (session?.installations || []).filter((i) => Number(i.organization_id) === orgId)
}

/** Org id for the active installation (keeps org selector aligned with snapshot). */
export function resolvePortalOrganizationId(session, installationId) {
  const id = Number(installationId)
  if (!id) return null
  const inst = collectInstallations(session).find((i) => Number(i.id) === id)
  if (inst?.organization_id) return Number(inst.organization_id)
  for (const org of session?.organizations || []) {
    const hit = (org.installations || []).find((i) => Number(i.id) === id)
    if (hit) return Number(org.id)
  }
  return null
}

/** @param {boolean} hasTwin */
export function syncTwinNavVisibility(root, hasTwin) {
  const twinBtn = root?.querySelector?.('#dash-twin-btn')
  if (twinBtn) twinBtn.hidden = !hasTwin
}

export function portalDashboardHasTwin(data) {
  if (!data) return false
  return data.has_twin === true || data.installation?.has_twin === true
}
